import { Brick, registerBrick, ErrorFlow } from 'olympe';
import sizeOf from 'browser-image-size';

export default class GetImageSize extends Brick {

    /**
     * @override
     * @protected
     * @param {!BrickContext} $
     * @param {File} image
     * @param {function(number)} setWidth
     * @param {function(number)} setHeight
     */
    async update($, [image], [setWidth, setHeight]) {
        try {
            const content = await image.getContentUrl();
            const dimensions = await sizeOf(content);
            setWidth(dimensions.width);
            setHeight(dimensions.height);
        } catch (error) {
            throw ErrorFlow.create(`Impossible to get the content of the file: ${error}`, 1);
        }
    }
}

registerBrick('018de576d9c1d1fd1e3b', GetImageSize);
